var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "planAdd",
      attrs: {
        "close-on-click-modal": false,
        title: "按时间批量添加班次",
        visible: _vm.visible,
        "append-to-body": true,
        width: "60%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "planForm", attrs: { model: _vm.planForm, size: "small" } },
        [
          _c("div", { staticClass: "tipsBox" }, [
            _c("img", {
              staticStyle: { width: "20px", height: "20px" },
              attrs: { src: require("./static/tips.png") },
            }),
            _c("span", [
              _vm._v(
                "选择当日运营起始时间，输入每个班次的间隔发班时间后点击“生成”！"
              ),
            ]),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      size: "small",
                      "picker-options": {
                        selectableRange:
                          "00:00:00 - " +
                          (_vm.end ? _vm.end + ":00" : "23:59:00"),
                      },
                      placeholder: "选择起始时间",
                    },
                    model: {
                      value: _vm.start,
                      callback: function ($$v) {
                        _vm.start = $$v
                      },
                      expression: "start",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 5 } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      size: "small",
                      "picker-options": {
                        selectableRange:
                          (_vm.start ? _vm.start + ":00" : "00:00:00") +
                          " - 23:59:00",
                      },
                      placeholder: "选择结束时间",
                    },
                    model: {
                      value: _vm.end,
                      callback: function ($$v) {
                        _vm.end = $$v
                      },
                      expression: "end",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("avue-input-number", {
                    staticStyle: { width: "8vw" },
                    attrs: { minRows: 0, maxRows: 120, size: "small" },
                    model: {
                      value: _vm.step,
                      callback: function ($$v) {
                        _vm.step = $$v
                      },
                      expression: "step",
                    },
                  }),
                  _c("span", [_vm._v("分钟/班")]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.createTimes },
                    },
                    [_vm._v("生成")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "班次时间:" } },
            _vm._l(_vm.planForm.times, function (item, index) {
              return _c(
                "span",
                { key: index, staticStyle: { padding: "2px" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        plain: "",
                        closable: "",
                      },
                      on: {
                        close: function ($event) {
                          return _vm.deleteTime(index)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(item.value) + "\n        ")]
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c("el-form-item", { attrs: { label: "价格方案：" } }),
          _c("div", { staticClass: "tipsBox" }, [
            _c("img", {
              staticStyle: { width: "20px", height: "20px" },
              attrs: { src: require("./static/tips.png") },
            }),
            _c("span", [_vm._v("根据班次、价格等选择班次的价格方案！")]),
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 9 } },
                [
                  _c("avue-select", {
                    staticStyle: { width: "20vw" },
                    attrs: {
                      placeholder: "请选择价格方案",
                      dic: _vm.priceMthodItems,
                      props: {
                        label: "priceMethodName",
                        value: "priceMethodId",
                      },
                      size: "small",
                    },
                    on: { change: _vm.handlePricemethod },
                    model: {
                      value: _vm.planForm.priceMethodId,
                      callback: function ($$v) {
                        _vm.$set(_vm.planForm, "priceMethodId", $$v)
                      },
                      expression: "planForm.priceMethodId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 3 } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.selePrice } },
                    [
                      _c("span", { staticStyle: { "font-size": "14px" } }, [
                        _vm._v("改价"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "站点设置：" } }, [
            _c("span", { staticStyle: { "margin-right": "15px" } }, [
              _vm._v(_vm._s(_vm.planForm.stationNameGroup)),
            ]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "司机车辆信息：" } },
            [
              _c("el-transfer", {
                ref: "transfer",
                attrs: {
                  filterable: "",
                  "filter-placeholder": "请输入搜索内容",
                  data: _vm.driverList,
                  titles: ["司机", "已选中司机"],
                  "target-order": "push",
                  "render-content": _vm.renderContent,
                },
                model: {
                  value: _vm.selectedList,
                  callback: function ($$v) {
                    _vm.selectedList = $$v
                  },
                  expression: "selectedList",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "标签：" } },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom",
                    width: "160",
                    trigger: "manual",
                  },
                  model: {
                    value: _vm.labelVisible,
                    callback: function ($$v) {
                      _vm.labelVisible = $$v
                    },
                    expression: "labelVisible",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        padding: "0px 0px 20px 20px",
                        "max-height": "200px",
                        "overflow-y": "scroll",
                      },
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { max: 2 },
                          model: {
                            value: _vm.labelCheck,
                            callback: function ($$v) {
                              _vm.labelCheck = $$v
                            },
                            expression: "labelCheck",
                          },
                        },
                        _vm._l(_vm.labelList, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.label,
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "el-checkbox",
                                { attrs: { label: item.type } },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["edit_label"],
                                      expression: "['edit_label']",
                                    },
                                  ],
                                  attrs: {
                                    size: "mini",
                                    type: "text",
                                    icon: "el-icon-edit",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAdd(item, "edit")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                编辑\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "flex flex-justify-between" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["add_label"],
                                expression: "['add_label']",
                              },
                            ],
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAdd({}, "add")
                              },
                            },
                          },
                          [_vm._v("\n              添加\n            ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                _vm.labelVisible = false
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.submitLabel()
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "add-labels",
                      attrs: { slot: "reference", type: "text" },
                      on: { click: _vm.addLabels },
                      slot: "reference",
                    },
                    [_vm._v("\n          添加\n        ")]
                  ),
                ],
                1
              ),
              _c(
                "span",
                _vm._l(_vm.labels, function (item, index) {
                  return _c(
                    "el-tag",
                    {
                      key: index,
                      staticStyle: { "margin-right": "5px" },
                      attrs: { closable: "", type: "warning", size: "small" },
                      on: {
                        close: function ($event) {
                          return _vm.handleCloseLabel(index)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.labelList.filter(function (it) {
                              return +it.id === item
                            })[0].name
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.cancel },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.save },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
      _vm.changePriceShow
        ? _c("price-view", {
            ref: "priceview",
            on: { revisePriceInfo: _vm.revisePriceInfo },
          })
        : _vm._e(),
      _vm.setStationShowDialog
        ? _c("set-station", {
            ref: "setStation",
            on: { LineFormData: _vm.handleLineFormData },
          })
        : _vm._e(),
      _vm.seleDriverShow
        ? _c("set-driver", {
            ref: "driverinfo",
            on: { DriverFormData: _vm.DriverFormData },
          })
        : _vm._e(),
      _c("AddLabel", {
        ref: "addLabel",
        on: {
          close: function ($event) {
            return _vm.$emit("addLabelClose")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }